// @ts-ignore
import {CommonModule} from '@angular/common';
// @ts-ignore
import {FormsModule} from '@angular/forms';
// @ts-ignore
import {ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild, signal, OnInit} from '@angular/core';
// @ts-ignore
import {Router} from '@angular/router';
import {SankhyaGatewayService} from '../../services/sankhya-gateway.service';
import {EmpresaStateService} from '../../services/empresa-state.service';
import {AuthService} from '../../services/auth.service';
import {MODELOS_COMPRA} from '../../pages/compra-impressao/compra-impressao.model';

export type GatewayView =
    'consultar-ipi' |
    'home' |
    'demonstrativo-vendas' |
    'gpl-transferencia' |
    'gpl-regras-comissao' |
    'lista-produtos' |
    'fabricantes' |
    'contas' |
    'gpl-holerites' |
    'duplicar-produto' |
    'gpl-edicaodeprodutos' |
    'gpl-venda-impressao' |
    'impressao-pre-compra' |
    'impressao-pre-compra-dolar' |
    'impressao-compra-internacional' |
    'impressao-compra-lista' |
    'impressao-pedido-compra' |
    'gpl-conferencia-cliente' |
    'pedido-venda' |
    'pedido-venda-lista' |
    'pre-venda' |
    'pre-venda-lista' |
    'controle-core' |
    'controle-forms' |
    'liberacao' |
    'motivo-cancelamento' |
    'controle-acessos' |
    'atividade-acessos' |
    'etiqueta-config' |
    'gpl-parametros' |
    'gpl-relatorios-comissoes' |
    'gpl-relatorio-comissionamento' |
    'gpl-manual' |
    'paineis-separacao' |
    'estoque-separacao' |
    'estoque-separacao-itens' |
    'estoque-separacao-itens-legado' |
    'itens-pendentes-legado' |
    'paineis-conferencia' |
    'paineis-logistica' |
    'estoque-conferencia' |
    'estoque-conferencia-itens' |
    'estoque-conferencia-itens-legado' |
    'estoque-logistica' |
    'estoque-logistica-itens' |
    'conferencia-pendente' |
    'conferencia-pendente-itens' |
    'comparacao-estoque' |
    'cadastro-parceiro' |
    'cadastro-aeronave' |
    'pedido-compra' |
    'pedido-compra-form' |
    'pre-compra-lista' |
    'pre-compra-form' |
    'compra-lista' |
    'compra-form' |
    'nota-control-teste' |
    'download-xml-compra';

type MenuGrupo =
    'reports' |
    'financeiro' |
    'stock' |
    'vendas' |
    'compras' |
    'parametrizacao' |
    'paineis' |
    'estoque' |
    'parceiros' |
    'aeronaves';

interface MenuItemPermissao {
    view: GatewayView;
    label: string;
    grupo: MenuGrupo;
    resourceId: string;
    permitido: boolean;
}

// @ts-ignore
@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.css'
})
export class MenuComponent implements OnInit {
    @ViewChild('menuScroll') private menuScroll?: ElementRef<HTMLElement>;

    @Input({required: true}) activeView: GatewayView = 'home';
    @Output() activeViewChange = new EventEmitter<GatewayView>();
    @Output() collapsedChange = new EventEmitter<boolean>();

    @Input() set isCollapsed(val: boolean) {
        this.collapsed.set(val);
    }

    collapsed = signal(false);
    loggingOut = signal(false);
    menuBusca = '';
    empresaDropdownAberto = false;
    permissoesCarregadas = false;
    menuPronto = false;
    private grupoRealUsuarioCache = new Map<string, string>();
    private grupoRealUsuarioResolvido: string | null = null;
    readonly relatoriosCompra: MenuItemPermissao[] = MODELOS_COMPRA.map(m => ({
        view: m.view as GatewayView, label: m.titulo, grupo: 'reports',
        resourceId: m.modelo === 'PEDIDO_COMPRA' ? 'gpl-sankhya.GPL_PedidoDeCompra' : 'gpl-sankhya.GPL_PreCompra',
        permitido: false
    }));
    itensMenuPermissao: MenuItemPermissao[] = [
        {
            view: 'gpl-transferencia',
            label: 'Transferência de Local',
            grupo: 'stock',
            resourceId: 'gpl-sankhya.GPL_TranferenciaLocal',
            permitido: false
        },
        {
            view: 'lista-produtos',
            label: 'Lista de Produtos',
            grupo: 'stock',
            // NOVO resourceId, mesmo passo manual das outras entradas novas
            // (Controle de Acessos do Sankhya).
            resourceId: 'gpl-sankhya.GPL_EdicaoDeProdutos',
            permitido: false
        },
        {
            view: 'duplicar-produto',
            label: 'Cadastrar',
            grupo: 'stock',
            resourceId: 'gpl-sankhya.GPL_cadastrar_produto',
            permitido: false
        },
        {
            view: 'gpl-edicaodeprodutos',
            label: 'Edição/Cotação',
            grupo: 'stock',
            resourceId: 'gpl-sankhya.GPL_EdicaoDeProdutos',
            permitido: false
        },
        {
            view: 'pedido-venda-lista',
            label: 'Pedido de Venda',
            grupo: 'vendas',
            resourceId: 'gpl-sankhya.GPL_vendas',
            permitido: false
        },
        {
            view: 'pre-venda-lista',
            label: 'Pré-Venda',
            grupo: 'vendas',
            resourceId: 'gpl-sankhya.GPL_PreVenda',
            permitido: false
        },
        {
            view: 'liberacao',
            label: 'Liberações',
            grupo: 'vendas',
            resourceId: 'gpl-sankhya.GPL_liberacao',
            permitido: false
        },
        {
            view: 'fabricantes',
            label: 'Fabricantes',
            grupo: 'stock',
            resourceId: 'br.com.sankhya.core.cad.marcas',
            permitido: false
        },
        {
            view: 'controle-core',
            label: 'Controle de Core',
            grupo: 'estoque',
            resourceId: 'br.com.sankhya.menu.adicional.AD_CONTROLECORE',
            permitido: false
        },
        {
            view: 'controle-forms',
            label: 'Controle de Forms',
            grupo: 'estoque',
            resourceId: 'br.com.sankhya.menu.adicional.AD_TGPCFC',
            permitido: false
        },
        {
            view: 'gpl-regras-comissao',
            label: 'Regras de Comissão',
            grupo: 'parametrizacao',
            resourceId: 'gpl-sankhya.GPL_RegrasComissao',
            permitido: false
        },
        {
            view: 'motivo-cancelamento',
            label: 'Motivos de Cancelamento',
            grupo: 'parametrizacao',
            resourceId: 'gpl-sankhya.GPL_motivos_de_cancelamento',
            permitido: false
        },
        {
            view: 'etiqueta-config',
            label: 'Configuração de Etiquetas',
            grupo: 'parametrizacao',
            resourceId: 'gpl-sankhya.GPL_configuracao_etiquetas',
            permitido: false
        },
        {
            view: 'gpl-parametros',
            label: 'Parâmetros do Sistema',
            grupo: 'parametrizacao',
            resourceId: 'gpl-sankhya.GPL_parametros',
            permitido: false
        },
        {
            view: 'contas',
            label: 'Contas',
            grupo: 'financeiro',
            resourceId: 'br.com.sankhya.fin.cad.contas',
            permitido: false
        },
        {
            view: 'gpl-holerites',
            label: 'Demonstrativos de Pagamento (Holerites)',
            grupo: 'financeiro',
            resourceId: 'br.com.sankhya.fin.cad.contas',
            permitido: false
        },
        {
            view: 'controle-acessos',
            label: 'Controle de Acessos',
            grupo: 'parametrizacao',
            resourceId: 'gpl-sankhya.GPL_controle_de_acessos',
            permitido: false
        },
        {
            view: 'atividade-acessos',
            label: 'Atividade de Acessos',
            grupo: 'parametrizacao',
            resourceId: 'gpl-sankhya.GPL_controle_de_acessos',
            permitido: false
        },
        {
            view: 'demonstrativo-vendas',
            label: 'Demonstrativo de Vendas',
            grupo: 'reports',
            resourceId: 'gpl-sankhya.GPL_DemonstrativoDeVendas',
            permitido: false
        },
        {
            view: 'gpl-conferencia-cliente',
            label: 'Conferencia Cliente',
            grupo: 'reports',
            resourceId: 'gpl-sankhya.GPL_ConferenciaCliente',
            permitido: false
        },
        {
            view: 'gpl-venda-impressao',
            label: 'Impressão de Venda',
            grupo: 'reports',
            resourceId: 'gpl-sankhya.GPL_VendaImpressao',
            permitido: false
        },
        {
            view: 'gpl-relatorios-comissoes',
            label: 'Relatórios de Comissões',
            grupo: 'reports',
            resourceId: 'gpl-sankhya.GPL_RelatorioComissoes',
            permitido: false
        },
        ...this.relatoriosCompra,
        {
            view: 'gpl-relatorio-comissionamento',
            label: 'Relatório de Comissionamento',
            grupo: 'reports',
            resourceId: 'gpl-sankhya.GPL_RelatorioComissionamento',
            permitido: false
        },
        {
            view: 'paineis-conferencia',
            label: 'Painel de Conferência',
            grupo: 'paineis',
            resourceId: 'gpl-sankhya.GPL_PainelConferencia',
            permitido: false
        },
        {
            view: 'paineis-logistica',
            label: 'Painel de Logística',
            grupo: 'paineis',
            resourceId: 'gpl-sankhya.GPL_PainelLogistica',
            permitido: false
        },
        {
            view: 'paineis-separacao',
            label: 'Separação',
            grupo: 'paineis',
            resourceId: 'gpl-sankhya.GPL_separacao',
            permitido: false
        },
        {
            view: 'estoque-separacao',
            label: 'Separação de Estoque',
            grupo: 'estoque',
            resourceId: 'gpl-sankhya.GPL_SeparacaoEstoque',
            permitido: false
        },
        {
            view: 'estoque-conferencia',
            label: 'Conferência de Estoque',
            grupo: 'estoque',
            resourceId: 'gpl-sankhya.GPL_ConferenciaEstoque',
            permitido: false
        },
        {
            view: 'estoque-logistica',
            label: 'Logística de Estoque',
            grupo: 'estoque',
            resourceId: 'gpl-sankhya.GPL_LogisticaEstoque',
            permitido: false
        },
        {
            view: 'conferencia-pendente',
            label: 'Conf. Pendente Vendedor',
            grupo: 'estoque',
            resourceId: 'gpl-sankhya.GPL_ConferenciaPendenteVendedor',
            permitido: false
        },
        {
            view: 'comparacao-estoque',
            label: 'Comparação de Estoque',
            grupo: 'estoque',
            resourceId: 'gpl-sankhya.GPL_ComparacaoEstoque',
            permitido: false
        },
        // 'itens-pendentes-legado' NÃO tem entrada aqui de propósito -- fica
        // aberto pra qualquer usuário logado (itemPermitidoPorView/
        // itemPermitidoPorLabel retornam true quando não encontram o view/label
        // na lista, mesmo comportamento de 'home' e 'gpl-manual'). Decisão
        // explícita do cliente: "Itens Pendentes" não deve depender de quem já
        // tem permissão de Separação de Estoque.
        {
            view: 'cadastro-parceiro',
            label: 'Cadastro de Parceiros',
            grupo: 'parceiros',
            resourceId: 'gpl-sankhya.GPL_CadastroParceiro',
            permitido: false
        },
        {
            view: 'pedido-compra',
            label: 'Pedido de Compra',
            grupo: 'compras',
            resourceId: 'gpl-sankhya.GPL_PedidoDeCompra',
            permitido: false
        },
        {
            view: 'consultar-ipi',
            label: 'Consultar IPI',
            grupo: 'compras',
            resourceId: 'gpl-sankhya.GPL_Compra',
            permitido: false
        },
        {
            view: 'download-xml-compra',
            label: 'Download XML Compra',
            grupo: 'compras',
            resourceId: 'gpl-sankhya.GPL_Compra',
            permitido: false
        },
        {
            view: 'pre-compra-lista',
            label: 'Pré-Compra',
            grupo: 'compras',
            // NOVO resourceId -- ainda precisa ser cadastrado no Controle de
            // Acessos do Sankhya (mesmo passo manual que todo item novo do
            // menu já exige aqui), senão só o usuário SUP enxerga este item.
            resourceId: 'gpl-sankhya.GPL_PreCompra',
            permitido: false
        },
        {
            view: 'compra-lista',
            label: 'Compra',
            grupo: 'compras',
            // NOVO resourceId, mesmo passo manual das outras entradas novas
            // (Controle de Acessos do Sankhya). TOP ainda é a 1301
            // (temporária, compartilhada com Pré-Compra) -- ver comentário
            // em compra-form.component.ts.
            resourceId: 'gpl-sankhya.GPL_Compra',
            permitido: false
        },
        {
            view: 'cadastro-aeronave',
            label: 'Cadastro de Aeronaves',
            grupo: 'aeronaves',
            resourceId: 'gpl-sankhya.GPL_CadastroAeronave',
            permitido: false
        },
        {
            view: 'nota-control-teste',
            label: 'NFS-e (Teste Nota Control)',
            grupo: 'parametrizacao',
            // NOVO resourceId, mesmo passo manual das outras entradas novas
            // (Controle de Acessos do Sankhya). Tela só de teste de
            // comunicação com o webservice -- não emite nada ainda.
            //
            // IMPORTANTE: não remova este item do array -- itemPermitidoPorView()
            // retorna `true` (libera) quando o view NÃO é encontrado na lista,
            // então tirar o item daqui teria o efeito contrário do desejado.
            // O botão real do menu está oculto direto no menu.component.html
            // (ver comentário lá) a pedido do usuário ("não vamos usar ela por
            // enquanto").
            resourceId: 'gpl-sankhya.GPL_NotaControlTeste',
            permitido: false
        },
    ];

    private ordenarMenuAlfabeticamente(): void {
        const menu = this.menuScroll?.nativeElement;

        if (!menu) {
            return;
        }

        const comparador = new Intl.Collator('pt-BR', {
            sensitivity: 'base',
            numeric: true,
            ignorePunctuation: true
        });

        /*
         * Ordena visualmente os grupos principais sem mover nós do DOM.
         *
         * A Home não possui .menu-group e, por isso, permanece com a ordem
         * padrão 0. Os grupos recebem order a partir de 1.
         *
         * Isso é importante porque os grupos são controlados pelo Angular
         * através de *ngIf. Alterar fisicamente a posição deles no DOM com
         * appendChild() quebra a relação entre as views do Angular e seus nós.
         */
        const grupos = Array.from(
            menu.querySelectorAll<HTMLElement>(
                ':scope > .menu-group'
            )
        );

        const gruposOrdenados = [...grupos].sort(
            (grupoA, grupoB) => {
                const labelA =
                    grupoA
                        .querySelector<HTMLElement>(
                            ':scope > .group-header .menu-label'
                        )
                        ?.textContent
                        ?.trim() ?? '';

                const labelB =
                    grupoB
                        .querySelector<HTMLElement>(
                            ':scope > .group-header .menu-label'
                        )
                        ?.textContent
                        ?.trim() ?? '';

                return comparador.compare(labelA, labelB);
            }
        );

        gruposOrdenados.forEach((grupo, indice) => {
            grupo.style.order = String(indice + 1);
        });

    }
    get empresaTexto(): string {
        if (this.empresa.carregando) return 'Carregando...';
        const e = this.empresa.opcoes.find(o => o.codEmp === this.empresa.selecionada);
        return e ? `${e.codEmp} - ${e.nomeFant || e.razaoAbrev}` : '';
    }

    toggleEmpresaDropdown(event?: MouseEvent): void {
        event?.stopPropagation();
        this.empresaDropdownAberto = !this.empresaDropdownAberto;
    }

    selecionarEmpresa(codEmp: string, event?: MouseEvent): void {
        event?.stopPropagation();
        // Passa pelo guard registrado (ver EmpresaStateService.registrarGuardaTroca)
        // -- se houver um Pedido de Venda em edição/lançamento aberto, ele
        // intercepta aqui e pergunta antes de trocar de verdade.
        this.empresa.solicitarTroca(codEmp);
        this.empresaDropdownAberto = false;
    }

    @HostListener('document:click', ['$event'])
    fecharEmpresaDropdownFora(event: MouseEvent): void {
        if (!this.empresaDropdownAberto) return;
        const alvo = event.target as Node | null;
        if (alvo && this.elementRef.nativeElement.contains(alvo)) return;
        this.empresaDropdownAberto = false;
    }

    emBusca(): boolean {
        return this.menuBusca.trim().length > 0;
    }

    bate(label: string): boolean {
        const q = this.menuBusca.trim().toLowerCase();
        if (!q) return false;
        return label.toLowerCase().includes(q);
    }

    mostraItem(label: string, grupoExpandido: boolean): boolean {
        if (this.collapsed()) return false;
        if (!this.itemPermitidoPorLabel(label)) return false;
        if (this.emBusca()) return this.bate(label);
        return grupoExpandido;
    }

    mostraGrupo(labels: string[], grupo?: MenuGrupo): boolean {
        if (grupo && !this.grupoTemItemPermitido(grupo)) return false;
        const labelsPermitidos = labels.filter((label) => this.itemPermitidoPorLabel(label));
        if (!labelsPermitidos.length) return false;
        if (!this.emBusca()) return true;
        return labelsPermitidos.some(l => this.bate(l));
    }

    mostraItemView(view: GatewayView, grupoExpandido: boolean): boolean {
        if (this.collapsed()) return false;
        if (!this.itemPermitidoPorView(view)) return false;
        if (this.emBusca()) return this.bate(this.labelMenu(view));
        return grupoExpandido;
    }

    mostraGrupoViews(views: GatewayView[], grupo?: MenuGrupo): boolean {
        if (grupo && !this.grupoTemItemPermitido(grupo)) return false;
        const labelsPermitidos = views
            .filter((view) => this.itemPermitidoPorView(view))
            .map((view) => this.labelMenu(view));
        if (!labelsPermitidos.length) return false;
        if (!this.emBusca()) return true;
        return labelsPermitidos.some((label) => this.bate(label));
    }

    reportsExpanded = signal(false);
    financeiroExpanded = signal(false);
    stockExpanded = signal(false);
    parametrizacaoExpanded = signal(false);
    vendasExpanded = signal(false);
    comprasExpanded = signal(false);
    paineisExpanded = signal(false);
    estoqueExpanded = signal(false);
    parceirosExpanded = signal(false);
    aeronavesExpanded = signal(false);

    get userName(): string {
        const name = this.valorSessao('userName');
        if (!name) return 'Usuário';
        // If it's a full email or long name, we can split it to show first name or clean it up
        return name.split(' ')[0];
    }

    constructor(
        private readonly elementRef: ElementRef<HTMLElement>,
        private readonly sankhyaGateway: SankhyaGatewayService,
        private readonly router: Router,
        private readonly authService: AuthService,
        readonly empresa: EmpresaStateService,
        private readonly cdr: ChangeDetectorRef
    ) {
    }

    ngOnInit(): void {
        this.empresa.carregar();
        void this.carregarPermissoesMenu();
        if (
            this.activeView === 'demonstrativo-vendas' ||
            this.activeView === 'gpl-conferencia-cliente' ||
            this.activeView === 'gpl-venda-impressao' ||
            this.relatoriosCompra.some(item => item.view === this.activeView) ||
            this.activeView === 'gpl-relatorios-comissoes'
        ) {
            this.reportsExpanded.set(true);
        }

        if (
            this.activeView === 'gpl-transferencia' ||
            this.activeView === 'lista-produtos' ||
            this.activeView === 'duplicar-produto' ||
            this.activeView === 'gpl-edicaodeprodutos'
        ) {
            this.stockExpanded.set(true);
        }

        if (this.activeView === 'gpl-regras-comissao' || this.activeView === 'motivo-cancelamento' || this.activeView === 'etiqueta-config' || this.activeView === 'controle-acessos' || this.activeView === 'atividade-acessos' || this.activeView === 'gpl-parametros') {
            this.parametrizacaoExpanded.set(true);
        }
        if (this.activeView === 'contas' || this.activeView === 'gpl-holerites') this.financeiroExpanded.set(true);

        if (this.activeView === 'pedido-venda' || this.activeView === 'pedido-venda-lista' || this.activeView === 'pre-venda' || this.activeView === 'pre-venda-lista' || this.activeView === 'liberacao') {
            this.vendasExpanded.set(true);
        }

        if (this.activeView === 'paineis-separacao' || this.activeView === 'paineis-conferencia' || this.activeView === 'paineis-logistica') {
            this.paineisExpanded.set(true);
        }

        if (this.activeView === 'estoque-separacao' || this.activeView === 'estoque-conferencia' || this.activeView === 'estoque-logistica' || this.activeView === 'estoque-logistica-itens' || this.activeView === 'conferencia-pendente' || this.activeView === 'conferencia-pendente-itens' || this.activeView === 'itens-pendentes-legado' || this.activeView === 'comparacao-estoque' || this.activeView === 'controle-core' || this.activeView === 'controle-forms') {
            this.estoqueExpanded.set(true);
        }

        if (this.activeView === 'cadastro-parceiro') {
            this.parceirosExpanded.set(true);
        }

        if (this.activeView === 'cadastro-aeronave') {
            this.aeronavesExpanded.set(true);
        }

        if (this.activeView === 'pedido-compra' || this.activeView === 'pedido-compra-form'
            || this.activeView === 'pre-compra-lista' || this.activeView === 'pre-compra-form'
            || this.activeView === 'compra-lista' || this.activeView === 'compra-form') {
            this.comprasExpanded.set(true);
        }
    }

    navigate(view: GatewayView): void {
        if (view !== 'home' && view !== 'gpl-manual' && !this.itemPermitidoPorView(view)) {
            return;
        }
        this.activeViewChange.emit(view);
        // Celular: depois de escolher uma tela, recolhe o menu lateral para mostrar o conteúdo.
        if (typeof window !== 'undefined' && window.innerWidth <= 900 && !this.collapsed()) this.toggleSidebar();
    }

    resourceId(view: GatewayView): string {
        return this.itensMenuPermissao.find((item) => item.view === view)?.resourceId || '';
    }

    labelMenu(view: GatewayView): string {
        return this.itensMenuPermissao.find((item) => item.view === view)?.label || '';
    }

    itemPermitidoPorView(view: GatewayView): boolean {
        const item = this.itensMenuPermissao.find((menuItem) => menuItem.view === view);
        return item ? item.permitido : true;
    }

    itemPermitidoPorLabel(label: string): boolean {
        const item = this.itensMenuPermissao.find((menuItem) => this.normalizar(menuItem.label) === this.normalizar(label));
        return item ? item.permitido : true;
    }

    grupoTemItemPermitido(grupo: MenuGrupo): boolean {
        return this.itensMenuPermissao.some((item) => item.grupo === grupo && item.permitido);
    }

    ordemGrupo(grupo: MenuGrupo): number {
        const grupos: Array<{ grupo: MenuGrupo; label: string }> = [
            {grupo: 'aeronaves', label: 'Aeronaves'},
            {grupo: 'compras', label: 'Compras'},
            {grupo: 'estoque', label: 'Estoque'},
            {grupo: 'financeiro', label: 'Financeiro'},
            {grupo: 'paineis', label: 'Painéis'},
            {grupo: 'parametrizacao', label: 'Parametrização'},
            {grupo: 'parceiros', label: 'Parceiros'},
            {grupo: 'stock', label: 'Produtos'},
            {grupo: 'reports', label: 'Relatórios'},
            {grupo: 'vendas', label: 'Vendas'},
        ];

        return grupos
            .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR', {sensitivity: 'base'}))
            .findIndex((item) => item.grupo === grupo) + 1;
    }

    ordemItem(view: GatewayView): number {
        void view;
        return 0;
    }

    private async carregarPermissoesMenu(): Promise<void> {
        const itens = [...this.itensMenuPermissao];
        const verificacoesPorResource = new Map<string, Promise<boolean>>();
        await this.prepararGrupoRealUsuario();
        // O grupo ja foi resolvido; limitar as chamadas simultaneas reduz a carga no gateway.
        const limiteConcorrencia = 4;
        let proximoItem = 0;

        console.groupCollapsed('[Menu][Permissao] Consultando itens do menu');

        const trabalhadores = Array.from(
            {length: Math.min(limiteConcorrencia, itens.length)},
            async () => {
                while (proximoItem < itens.length) {
                    const indice = proximoItem++;
                    const item = itens[indice];
                    console.groupCollapsed(`[Menu][Permissao][Item] ${item.label} -> ${item.resourceId}`);
                    console.log('Item:', item);
                    console.log('Sessao:', {
                        usuario: this.valorSessao('userName'),
                        usuarioId: this.valorSessao('userId'),
                        grupo: this.valorSessao('userGroup')
                    });

                    let verificacao = verificacoesPorResource.get(item.resourceId);
                    if (!verificacao) {
                        verificacao = this.usuarioTemPermissaoNoResourceComRetry(item.resourceId);
                        verificacoesPorResource.set(item.resourceId, verificacao);
                    }

                    item.permitido = await verificacao;
                    console.log('Resultado final:', {
                        label: item.label,
                        resourceId: item.resourceId,
                        permitido: item.permitido
                    });
                    console.groupEnd();
                }
            }
        );

        await Promise.all(trabalhadores);

        console.groupEnd();

        this.itensMenuPermissao = itens;

        /*
         * 1. Terminou de carregar tudo.
         * 2. Libera o Angular para montar o menu.
         * 3. O loading AINDA continua aparecendo.
         */
        this.permissoesCarregadas = true;

        /*
         * Força o Angular a criar os elementos do menu no DOM
         * antes de tentar ordená-los.
         */
        this.cdr.detectChanges();

        /*
         * Agora que todo o menu permitido existe no DOM,
         * ordena alfabeticamente.
         */
        this.ordenarMenuAlfabeticamente();

        /*
         * Só depois de ordenar, fecha o loading.
         */
        this.menuPronto = true;

        this.cdr.detectChanges();

        if (
            this.activeView !== 'home' &&
            this.activeView !== 'gpl-manual' &&
            !this.itemPermitidoPorView(this.activeView)
        ) {
            this.navigate('home');
        }
    }

    private async prepararGrupoRealUsuario(): Promise<void> {
        if (this.usuarioSup()) return;

        const grupoSessao = this.normalizar(this.valorSessao('userGroup'));
        if (this.grupoSessaoEhValido(grupoSessao)) {
            this.grupoRealUsuarioResolvido = grupoSessao;
            return;
        }

        const usuarioNome = this.normalizar(this.valorSessao('userName'));
        const usuarioId = this.normalizar(this.valorSessao('userId'));
        if (!usuarioNome && !usuarioId) return;

        const recursos = Array.from(new Set([
            ...this.itensMenuPermissao.map(item => item.resourceId),
            ...this.relatoriosCompra.map(item => item.resourceId)
        ]));

        for (const resourceId of recursos) {
            try {
                const usuariosComAcesso = await this.buscarEntidadesAcessoMenu(resourceId, 'USUARIO', false);
                let usuario = this.encontrarUsuarioNasEntidades(usuariosComAcesso, usuarioNome, usuarioId);

                if (!usuario) {
                    const usuariosSemAcesso = await this.buscarEntidadesAcessoMenu(resourceId, 'USUARIO', true);
                    usuario = this.encontrarUsuarioNasEntidades(usuariosSemAcesso, usuarioNome, usuarioId);
                }

                const agrupamento = this.extrairCodigoOuDescricao(
                    usuario?.agrupamento ?? usuario?.AGRUPAMENTO ?? usuario?.grupo ?? usuario?.GRUPO
                );
                if (agrupamento) {
                    this.grupoRealUsuarioResolvido = agrupamento;
                    this.gravarGrupoRealUsuario(agrupamento);
                    console.debug('[Menu][Permissao] Grupo do usuario resolvido antes das verificacoes:', resourceId);
                    return;
                }
            } catch (error) {
                console.warn('[Menu][Permissao] Falha ao resolver grupo no resource; tentando o proximo:', resourceId, error);
            }
        }
    }

    private encontrarUsuarioNasEntidades(usuarios: any[], usuarioNome: string, usuarioId: string): any | undefined {
        return usuarios.find((item) => {
            const descricao = this.normalizar(item?.descricao ?? item?.DESCRICAO ?? item?.nome ?? item?.NOME);
            const id = this.normalizar(item?.id ?? item?.ID ?? item?.codigo ?? item?.CODIGO);
            return (!!usuarioNome && descricao === usuarioNome) || (!!usuarioId && id === usuarioId);
        });
    }

    private async usuarioTemPermissaoNoResource(resourceId: string): Promise<boolean> {
        if (this.usuarioSup()) {
            return true;
        }

        const permissaoUsuario = await this.alvoTemPermissaoNoResource(resourceId, 'USUARIO');
        const permissaoGrupo = await this.alvoTemPermissaoNoResource(resourceId, 'GRUPO');
        const permitido = permissaoUsuario || permissaoGrupo;

        console.debug('[Menu][Permissao]', {
            resourceId,
            usuario: this.valorSessao('userName'),
            usuarioId: this.valorSessao('userId'),
            grupo: this.valorSessao('userGroup'),
            permissaoUsuario,
            permissaoGrupo,
            permitido
        });

        return permitido;
    }

    private async usuarioTemPermissaoNoResourceComRetry(resourceId: string): Promise<boolean> {
        for (let tentativa = 1; tentativa <= 2; tentativa++) {
            try {
                return await this.usuarioTemPermissaoNoResource(resourceId);
            } catch (error) {
                this.grupoRealUsuarioCache.delete(resourceId);
                if (tentativa === 2) {
                    console.warn('[Menu] Falha ao consultar permissao do resourceID apos nova tentativa:', resourceId, error);
                    return false;
                }
                console.warn('[Menu] Falha temporaria ao consultar permissao; tentando novamente:', resourceId, error);
            }
        }

        return false;
    }

    private usuarioSup(): boolean {
        const usuarioId = String(this.valorSessao('userId') || '').trim();
        const usuarioNome = this.normalizar(this.valorSessao('userName'));

        return usuarioId === '0' || usuarioNome === 'SUP';
    }

    private async alvoTemPermissaoNoResource(resourceId: string, tipo: 'USUARIO' | 'GRUPO'): Promise<boolean> {
        const codigo = tipo === 'USUARIO'
            ? await this.codigoUsuarioPermissao(resourceId)
            : await this.codigoGrupoPermissao(resourceId);

        if (!codigo) {
            return false;
        }

        const permissoes = await this.buscarPermissoesAcessoMenu(resourceId, tipo, codigo);
        return this.temAlgumaPermissao(permissoes);
    }

    private async codigoUsuarioPermissao(resourceId: string): Promise<string> {
        const usuarioId = String(this.valorSessao('userId') || '').trim();

        if (/^\d+$/.test(usuarioId)) {
            return usuarioId;
        }

        const usuarioNome = this.normalizar(this.valorSessao('userName'));
        if (!usuarioNome) {
            return '';
        }

        const usuarios = await this.buscarEntidadesAcessoMenu(resourceId, 'USUARIO');
        const usuario = usuarios.find((item) => {
            const descricao = this.normalizar(item?.descricao ?? item?.DESCRICAO ?? item?.nome ?? item?.NOME);
            return descricao === usuarioNome;
        });

        return usuario?.id || usuario?.ID ? String(usuario.id ?? usuario.ID) : '';
    }

    private async codigoGrupoPermissao(
        resourceId: string
    ): Promise<string> {

        const grupoResolvido = await this.grupoRealUsuario(
            resourceId
        );

        const grupoNormalizado = this.normalizar(
            grupoResolvido
        );

        if (!grupoNormalizado) {
            console.debug(
                '[Menu][Permissao][codigoGrupoPermissao] Grupo não resolvido',
                {resourceId}
            );

            return '';
        }

        /*
         * Se o agrupamento já veio como código numérico,
         * usa diretamente.
         */
        if (/^\d+$/.test(grupoNormalizado)) {
            return grupoNormalizado;
        }

        const grupos = await this.buscarEntidadesAcessoMenu(
            resourceId,
            'GRUPO',
            false
        );

        const grupo = grupos.find((item) => {
            const descricao = this.normalizar(
                item?.descricao ??
                item?.DESCRICAO ??
                item?.nome ??
                item?.NOME
            );

            const id = this.normalizar(
                item?.id ??
                item?.ID ??
                item?.codigo ??
                item?.CODIGO ??
                item?.value ??
                item?.VALUE
            );

            return descricao === grupoNormalizado ||
                id === grupoNormalizado;
        });

        const codigo =
            grupo?.id ??
            grupo?.ID ??
            grupo?.codigo ??
            grupo?.CODIGO ??
            grupo?.value ??
            grupo?.VALUE;

        const resultado =
            codigo !== null && codigo !== undefined
                ? String(codigo)
                : '';

        console.debug(
            '[Menu][Permissao][codigoGrupoPermissao]',
            {
                resourceId,
                grupoResolvido,
                grupoNormalizado,
                grupos,
                grupoEncontrado: grupo,
                resultado
            }
        );

        return resultado;
    }

    private async grupoRealUsuario(resourceId: string): Promise<string> {
        if (this.grupoRealUsuarioResolvido) {
            this.grupoRealUsuarioCache.set(resourceId, this.grupoRealUsuarioResolvido);
            return this.grupoRealUsuarioResolvido;
        }

        const grupoCache = this.grupoRealUsuarioCache.get(resourceId);

        if (grupoCache !== undefined) {
            return grupoCache;
        }

        const usuarioNome = this.normalizar(
            this.valorSessao('userName')
        );

        const usuarioId = this.normalizar(
            this.valorSessao('userId')
        );

        if (usuarioNome || usuarioId) {
            /*
             * IMPORTANTE:
             * semAcesso deve ser false.
             */
            const usuariosComAcesso = await this.buscarEntidadesAcessoMenu(
                resourceId,
                'USUARIO',
                false
            );

            const usuariosSemAcesso = await this.buscarEntidadesAcessoMenu(
                resourceId,
                'USUARIO',
                true
            );

            const usuarios = [
                ...usuariosComAcesso,
                ...usuariosSemAcesso
            ];

            const usuario = usuarios.find((item) => {
                const descricao = this.normalizar(
                    item?.descricao ??
                    item?.DESCRICAO ??
                    item?.nome ??
                    item?.NOME
                );

                const id = this.normalizar(
                    item?.id ??
                    item?.ID ??
                    item?.codigo ??
                    item?.CODIGO
                );

                return descricao === usuarioNome ||
                    id === usuarioId;
            });

            const agrupamentoBruto =
                usuario?.agrupamento ??
                usuario?.AGRUPAMENTO ??
                usuario?.grupo ??
                usuario?.GRUPO;

            const agrupamento = this.extrairCodigoOuDescricao(
                agrupamentoBruto
            );

            console.debug('[Menu][Permissao][grupoRealUsuario]', {
                resourceId,
                usuarioNome,
                usuarioId,
                usuarioEncontrado: usuario,
                agrupamentoBruto,
                agrupamento
            });

            if (agrupamento) {
                this.grupoRealUsuarioResolvido = agrupamento;
                this.grupoRealUsuarioCache.set(
                    resourceId,
                    agrupamento
                );

                this.gravarGrupoRealUsuario(agrupamento);

                return agrupamento;
            }
        }

        const grupoSessao = this.normalizar(
            this.valorSessao('userGroup')
        );

        const resultado = this.grupoSessaoEhValido(grupoSessao)
            ? grupoSessao
            : '';

        if (resultado) {
            this.grupoRealUsuarioResolvido = resultado;
        }

        this.grupoRealUsuarioCache.set(resourceId, resultado);

        return resultado;
    }

    private extrairCodigoOuDescricao(valor: unknown): string {
        if (valor === null || valor === undefined) {
            return '';
        }

        if (
            typeof valor === 'string' ||
            typeof valor === 'number'
        ) {
            return this.normalizar(valor);
        }

        if (typeof valor === 'object') {
            const objeto = valor as any;

            return this.normalizar(
                objeto?.id ??
                objeto?.ID ??
                objeto?.codigo ??
                objeto?.CODIGO ??
                objeto?.value ??
                objeto?.VALUE ??
                objeto?.descricao ??
                objeto?.DESCRICAO ??
                objeto?.nome ??
                objeto?.NOME ??
                objeto?.$
            );
        }

        return '';
    }

    private grupoSessaoEhValido(grupo: string): boolean {
        return !!grupo && grupo !== 'LOCAL' && grupo !== 'LOC' && grupo !== 'SANKHYA-OM';
    }

    private gravarGrupoRealUsuario(grupo: string): void {
        const tipo = localStorage.getItem('authStorageType');
        const storage = tipo === 'session' ? sessionStorage : localStorage;
        storage.setItem('userGroup', grupo);
    }

    private async buscarPermissoesAcessoMenu(resourceId: string, tipo: 'USUARIO' | 'GRUPO', codigo: string): Promise<any[]> {
        const payload = {
            permissao: {
                modoAcesso: tipo === 'USUARIO' ? 'usuario' : 'grupo',
                itens: {
                    item: {
                        resourceID: resourceId
                    }
                },
                usuarios: {
                    usuario: {
                        value: String(codigo)
                    }
                }
            },
            clientEventList: {}
        };

        console.log(`[Menu][Permissao][Payload getPermissaoAcesso ${tipo}]`, payload);

        const resposta: any = await new Promise((resolve, reject) => {
            this.sankhyaGateway.listarPermissaoAcessoControleAcesso(resourceId, tipo, codigo).subscribe({
                next: resolve,
                error: reject
            });
        });
        const lista = this.extrairListaPermissaoMenu(resposta);

        console.log(`[Menu][Permissao][Response getPermissaoAcesso ${tipo}]`, resposta);
        console.log(`[Menu][Permissao][Lista getPermissaoAcesso ${tipo}]`, lista);

        return lista;
    }

    private temAlgumaPermissao(permissoes: any[]): boolean {
        return permissoes.some((item) => this.flagPermissao(item?.permissao ?? item?.PERMISSAO));
    }

    private flagPermissao(valor: unknown): boolean {
        return valor === true ||
            valor === 'true' ||
            valor === 'TRUE' ||
            valor === 'S' ||
            valor === '1' ||
            valor === 1;
    }

    private async buscarEntidadesAcessoMenu(resourceId: string, tipo: 'USUARIO' | 'GRUPO', semAcesso = false): Promise<any[]> {
        const payload = {
            itens: {
                modoAcesso: tipo === 'USUARIO' ? 'usuario' : 'grupo',
                semAcesso: semAcesso ? 'true' : 'false',
                considerarAcessoNegado: 'true',
                item: [
                    {
                        resourceID: resourceId
                    }
                ]
            },
            clientEventList: {}
        };

        console.log(`[Menu][Permissao][Payload getEntidadesAcesso ${tipo}]`, payload);

        const resposta: any = await new Promise((resolve, reject) => {
            this.sankhyaGateway.listarEntidadesAcessoControleAcesso([resourceId], tipo, semAcesso).subscribe({
                next: resolve,
                error: reject
            });
        });
        const lista = this.extrairListaPermissaoMenu(resposta);

        console.log(`[Menu][Permissao][Response getEntidadesAcesso ${tipo}]`, resposta);
        console.log(`[Menu][Permissao][Lista getEntidadesAcesso ${tipo}]`, lista);

        return lista;
    }

    private extrairListaPermissaoMenu(resposta: any): any[] {
        if (!resposta) return [];
        if (Array.isArray(resposta)) return resposta;

        const body = resposta.responseBody ?? resposta.serviceResponse?.responseBody ?? resposta;
        if (Array.isArray(body)) return body;
        if (Array.isArray(body?.json)) return body.json;
        if (typeof body?.json === 'string') return this.parseListaJson(body.json);
        if (typeof body?.json?.$ === 'string') return this.parseListaJson(body.json.$);
        if (typeof body?.json?._ === 'string') return this.parseListaJson(body.json._);
        if (body?.responseBody) return this.extrairListaPermissaoMenu(body.responseBody);
        if (typeof body === 'string') return this.parseListaJson(body);
        return [];
    }

    private parseListaJson(valor: string): any[] {
        try {
            const cdata = valor.match(/<!\[CDATA\[([\s\S]*?)\]\]>/);
            const parsed = JSON.parse(cdata?.[1] || valor);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }

    private normalizar(valor: unknown): string {
        return String(valor ?? '').trim().toUpperCase();
    }

    private valorSessao(chave: string): string {
        const tipo = localStorage.getItem('authStorageType');
        if (tipo === 'session') {
            return sessionStorage.getItem(chave) || '';
        }
        return localStorage.getItem(chave) || '';
    }

    toggleReports(): void {
        if (this.collapsed()) {
            this.toggleSidebar();
            this.expandirSomente('reports');
        } else {
            this.alternarGrupo('reports');
        }
    }

    toggleStock(): void {
        if (this.collapsed()) {
            this.toggleSidebar();
            this.expandirSomente('stock');
        } else {
            this.alternarGrupo('stock');
        }
    }

    toggleParceiros(): void {
        if (this.collapsed()) {
            this.toggleSidebar();
            this.expandirSomente('parceiros');
        } else {
            this.alternarGrupo('parceiros');
        }
    }

    toggleAeronaves(): void {
        if (this.collapsed()) {
            this.toggleSidebar();
            this.expandirSomente('aeronaves');
        } else {
            this.alternarGrupo('aeronaves');
        }
    }

    toggleCompras(): void {
        if (this.collapsed()) {
            this.toggleSidebar();
            this.expandirSomente('compras');
        } else {
            this.alternarGrupo('compras');
        }
    }

    toggleVendas(): void {
        if (this.collapsed()) {
            this.toggleSidebar();
            this.expandirSomente('vendas');
        } else {
            this.alternarGrupo('vendas');
        }
    }

    toggleParametrizacao(): void {
        if (this.collapsed()) {
            this.toggleSidebar();
            this.expandirSomente('parametrizacao');
        } else {
            this.alternarGrupo('parametrizacao');
        }
    }

    toggleFinanceiro(): void {
        if (this.collapsed()) {
            this.toggleSidebar();
            this.expandirSomente('financeiro');
        } else {
            this.alternarGrupo('financeiro');
        }
    }

    togglePaineis(): void {
        if (this.collapsed()) {
            this.toggleSidebar();
            this.expandirSomente('paineis');
        } else {
            this.alternarGrupo('paineis');
        }
    }

    toggleEstoque(): void {
        if (this.collapsed()) {
            this.toggleSidebar();
            this.expandirSomente('estoque');
        } else {
            this.alternarGrupo('estoque');
        }
    }

    private alternarGrupo(grupo: 'reports' | 'financeiro' | 'stock' | 'vendas' | 'compras' | 'parametrizacao' | 'paineis' | 'estoque' | 'parceiros' | 'aeronaves'): void {
        const deveExpandir = !this.grupoExpandido(grupo);

        if (deveExpandir) {
            this.expandirSomente(grupo);
            return;
        }

        this.definirGrupo(grupo, false);
    }

    private expandirSomente(grupo: 'reports' | 'financeiro' | 'stock' | 'vendas' | 'compras' | 'parametrizacao' | 'paineis' | 'estoque' | 'parceiros' | 'aeronaves'): void {
        this.reportsExpanded.set(grupo === 'reports');
        this.financeiroExpanded.set(grupo === 'financeiro');
        this.stockExpanded.set(grupo === 'stock');
        this.vendasExpanded.set(grupo === 'vendas');
        this.comprasExpanded.set(grupo === 'compras');
        this.parceirosExpanded.set(grupo === 'parceiros');
        this.aeronavesExpanded.set(grupo === 'aeronaves');
        this.parametrizacaoExpanded.set(grupo === 'parametrizacao');
        this.paineisExpanded.set(grupo === 'paineis');
        this.estoqueExpanded.set(grupo === 'estoque');

        this.cdr.detectChanges();
        this.ordenarMenuAlfabeticamente();

        this.ajustarScrollDoGrupoExpandido();
    }

    private ajustarScrollDoGrupoExpandido(): void {
        requestAnimationFrame(() => {
            const menu = this.menuScroll?.nativeElement;
            const grupo = menu?.querySelector<HTMLElement>('.menu-group.expanded');
            if (!menu || !grupo) return;

            const margem = 8;
            const menuRect = menu.getBoundingClientRect();
            const grupoRect = grupo.getBoundingClientRect();
            const alturaVisivel = menu.clientHeight;
            const alturaGrupo = grupoRect.height;

            let deslocamento = 0;
            if (alturaGrupo > alturaVisivel) {
                deslocamento = grupoRect.top - menuRect.top - margem;
            } else if (grupoRect.bottom > menuRect.bottom - margem) {
                deslocamento = grupoRect.bottom - menuRect.bottom + margem;
            } else if (grupoRect.top < menuRect.top + margem) {
                deslocamento = grupoRect.top - menuRect.top - margem;
            }

            if (deslocamento !== 0) {
                menu.scrollTo({top: menu.scrollTop + deslocamento, behavior: 'smooth'});
            }
        });
    }

    private grupoExpandido(grupo: 'reports' | 'financeiro' | 'stock' | 'vendas' | 'compras' | 'parametrizacao' | 'paineis' | 'estoque' | 'parceiros' | 'aeronaves'): boolean {
        if (grupo === 'reports') return this.reportsExpanded();
        if (grupo === 'financeiro') return this.financeiroExpanded();
        if (grupo === 'stock') return this.stockExpanded();
        if (grupo === 'vendas') return this.vendasExpanded();
        if (grupo === 'compras') return this.comprasExpanded();
        if (grupo === 'paineis') return this.paineisExpanded();
        if (grupo === 'estoque') return this.estoqueExpanded();
        if (grupo === 'parceiros') return this.parceirosExpanded();
        if (grupo === 'aeronaves') return this.aeronavesExpanded();
        return this.parametrizacaoExpanded();
    }

    private definirGrupo(grupo: 'reports' | 'financeiro' | 'stock' | 'vendas' | 'compras' | 'parametrizacao' | 'paineis' | 'estoque' | 'parceiros' | 'aeronaves', expandido: boolean): void {
        if (grupo === 'reports') this.reportsExpanded.set(expandido);
        if (grupo === 'financeiro') this.financeiroExpanded.set(expandido);
        if (grupo === 'stock') this.stockExpanded.set(expandido);
        if (grupo === 'vendas') this.vendasExpanded.set(expandido);
        if (grupo === 'compras') this.comprasExpanded.set(expandido);
        if (grupo === 'parametrizacao') this.parametrizacaoExpanded.set(expandido);
        if (grupo === 'paineis') this.paineisExpanded.set(expandido);
        if (grupo === 'estoque') this.estoqueExpanded.set(expandido);
        if (grupo === 'parceiros') this.parceirosExpanded.set(expandido);
        if (grupo === 'aeronaves') this.aeronavesExpanded.set(expandido);
    }

    toggleSidebar(): void {
        this.collapsed.update((collapsed: any) => !collapsed);
        this.collapsedChange.emit(this.collapsed());
    }

    sair(): void {
        this.loggingOut.set(true);
        this.sankhyaGateway.logout().subscribe({
            next: () => this.voltarLogin(),
            error: () => this.voltarLogin()
        });
    }

    private voltarLogin(): void {
        // Limpa também o cache de identidade em memória (codusuCache) do AuthService.
        // Sem isso, ele sobrevive à navegação (é um singleton) e o próximo login,
        // se feito na mesma aba, herdava o CODUSU do usuário anterior — causando as
        // telas de Separação/Conferência de Estoque a mostrarem dados de quem saiu.
        //
        // IMPORTANTE: clearSession() já remove (via removeItem) tudo que é de
        // autenticação, em local/sessionStorage. NÃO usar localStorage.clear()/
        // sessionStorage.clear() aqui -- isso apagava também preferências que
        // não têm nada a ver com login, como a identificação (TAG + usuário)
        // lembrada por venda na Separação do Sistema Legado (ver
        // _salvarIdentificacao em estoque-separacao-itens-legado.component.ts)
        // e a empresa Legado lembrada nos painéis -- por isso o separador
        // saía do sistema, voltava pra continuar a MESMA separação, e a TAG
        // que ele já tinha informado sumia, pedindo tudo de novo.
        this.authService.clearSession();
        this.loggingOut.set(false);
        this.router.navigate(['/login']);
    }
}
